import React, { useState, useEffect } from "react";
import PolyProps from "./PolyPropss"; // Matches existing file name
import pp from "../../assets/pp.png";
import pc1 from "../../assets/pc1.png";
import pc2 from "../../assets/pc2.png";
import flagPakistan from "../../assets/pakistan.png";
import flagJapan from "../../assets/japan.png";
import flagSaudiArabia from "../../assets/saudi_arabia.png";
import flagNorway from "../../assets/norway.png";
import flagUAE from "../../assets/united_arab_emirates.png";
import flagUSA from "../../assets/united_states_of_america.png";
import s1age4 from "../../assets/s1age4.png";
import s1age7 from "../../assets/s1age7.png";
import s1age11 from "../../assets/s1age11.png";
import s2age4 from "../../assets/s2age4.png";
import s2age7 from "../../assets/s2age7.png";
import s2age11 from "../../assets/s2age11.png";
import s3age4 from "../../assets/s3age4.png";
import s3age7 from "../../assets/s3age7.png";
import s3age11 from "../../assets/s3age11.png";
import axios from 'axios';

const Coding = () => {
  const [competitionData, setCompetitionData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch competition data from database
  useEffect(() => {
    const fetchCompetitionData = async () => {
      try {
        const response = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/allpolymatchcompetition`);
        if (response.data && response.data.length > 0) {
          // Filter competitions that contain "coding" in the name (case insensitive)
          const codingCompetitions = response.data.filter(comp => 
            comp.Competition_Name && comp.Competition_Name.toLowerCase().includes('coding')
          );
          setCompetitionData(codingCompetitions);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching competition data:', error);
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, []);

  const headerSection = {
    mainHeading: "Coding Competition",
    subHeading: "Stay Tuned",
    mainImage: pp,
    leftImage: pc1,
    rightImage: pc2,
  };

  const upcomingCompetitionSection = {
    mainHeading: "For Our Upcoming Competition",
    subHeading: "Stay Tuned",
    competitionName: "Coding Skills Competition",
    description:
      "The PolyMatch Coding Competition ignites curiosity and celebrates the art of programming from around the world. This exciting event brings together brilliant minds to explore concepts in algorithms, software development, and beyond. Encouraging innovation, problem-solving, and technical mastery, participants enhance their coding skills while building meaningful global connections in a dynamic and inspiring atmosphere",
    registerLink: "/PolymatchReg",
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  // Dynamic competition years section based on database data
  const competitionYearsSection = {
    mainHeading: "Coding Competition",
    defaultYear: 2025,
    years: competitionData.map(comp => ({
      year: new Date(comp.Competition_date).getFullYear(),
      title: comp.Competition_Name,
      dates: new Date(comp.Competition_date).toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }),
      description: comp.Competition_Description || "No competition is held yet. Stay tuned for updates!",
      competitionId: comp.Competition_Id,
    })),
    flags: [
      { src: flagPakistan, alt: "Pakistan Flag" },
      { src: flagJapan, alt: "Japan Flag" },
      { src: flagSaudiArabia, alt: "Saudi Arabia Flag" },
      { src: flagNorway, alt: "Norway Flag" },
      { src: flagUAE, alt: "United Arab Emirates Flag" },
      { src: flagUSA, alt: "United States of America Flag" },
    ],
  };

  const winnersSection = {
    mainHeading: "Congratulations to All Winners!",
    description:
      "We're proud of every participant, and we applaud the outstanding winners who showcased exceptional skills, creativity, and determination. Your hard work truly shines—well done!",
    winners: [
      {
        year: 2025,
        image: "PolymatchImages/student1.png",
        alt: "Age 4-5 Winner",
        ageCategory: "Ages 4-5",
        studentsData: [
          {
            name: "Emaan Omar",
            rank: "1st Winner",
            country: "Karachi, Pakistan",
            age: "5 Years",
            image: 'PolymatchImages/student1.png',
          },
          {
            name: "Hamza Khan",
            rank: "2nd Winner",
            country: "Karachi, Pakistan",
            age: "4 Years",
            image: 'PolymatchImages/student1.png',
          },
          {
            name: "Ali Khan",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "5 Years",
            image: 'PolymatchImages/student1.png',
          },
        ],
      },
      {
        year: 2025,
        image: "PolymatchImages/student1.png",
        alt: "Age 6-8 Winner",
        ageCategory: "Ages 6-8",
        studentsData: [
          {
            name: "Sarah Ahmed",
            rank: "1st Winner",
            country: "Lahore, Pakistan",
            age: "7 Years",
            image: "PolymatchImages/student1.png",
          },
          {
            name: "Ahmed Hassan",
            rank: "2nd Winner",
            country: "Islamabad, Pakistan",
            age: "6 Years",
          },
          {
            name: "Fatima Ali",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "8 Years",
          },
        ],
      },
      {
        year: 2025,
        image: "PolymatchImages/student1.png",
        alt: "Age 9-11 Winner",
        ageCategory: "Ages 9-11",
        studentsData: [
          {
            name: "Zain Khan",
            rank: "1st Winner",
            country: "Dubai, UAE",
            age: "10 Years",
            image: "PolymatchImages/student1.png",
          },
          {
            name: "Aisha Malik",
            rank: "2nd Winner",
            country: "Riyadh, Saudi Arabia",
            age: "9 Years",
          },
          {
            name: "Omar Sheikh",
            rank: "3rd Winner",
            country: "Oslo, Norway",
            age: "11 Years",
          },
        ],
      },
      {
        year: 2025,
        image: "PolymatchImages/student1.png",
        alt: "Age 12-15 Winner",
        ageCategory: "Ages 12-15",
        studentsData: [
          {
            name: "Hassan Raza",
            rank: "1st Winner",
            country: "Tokyo, Japan",
            age: "13 Years",
            image: "PolymatchImages/student1.png",
          },
          {
            name: "Mariam Khan",
            rank: "2nd Winner",
            country: "New York, USA",
            age: "14 Years",
          },
          {
            name: "Yusuf Ali",
            rank: "3rd Winner",
            country: "Karachi, Pakistan",
            age: "12 Years",
          },
        ],
      },
    ],
    resultsLink: "/PolymatchResults_Linguistic",
  };

  const spotlightSection = {
    mainHeading: "Participant Spotlight",
    subHeading: " – Watch Them in Action",
    description:
      "Get inspired by the creativity, confidence, and talent of our young competitors. These videos showcase real moments from PolyMatch participants sharing their experiences, solving coding challenges, and celebrating success.",
    participants: [
      {
        name: "Sample Participant",
        compName: "Coding Competition 2025",
        rank: "Sample Winner – Age Category 9 - 11",
        country: "From Pakistan",
        video: null,
      },
      // {
      //   name: "Emaan Omar",
      //   compName: "Coding Competition 2024",
      //   rank: "3rd Winner – Age Category 9 - 11",
      //   country: "From Pakistan",
      //   video: null,
      // },
      // ... (other participants commented out)
    ],
  };

  // Show loading state while fetching data
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading competition data...
      </div>
    );
  }

  // Show message if no coding competitions found
  if (!competitionData || competitionData.length === 0) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '50vh',
        fontSize: '18px',
        color: '#666',
        textAlign: 'center',
        padding: '20px'
      }}>
        <div>
          <h3>No coding competitions found</h3>
          <p>Please check back later for upcoming coding competitions.</p>
        </div>
      </div>
    );
  }

  return (
    <PolyProps
      headerSection={headerSection}
      upcomingCompetitionSection={upcomingCompetitionSection}
      competitionYearsSection={competitionYearsSection}
      winnersSection={winnersSection}
      spotlightSection={spotlightSection}
    />
  );
};

export default Coding;